import actionsSuppliergroup from "./actions";

export default {
  namespaced: false,
  actions: actionsSuppliergroup,
};
